import { useEffect, useState } from 'react';
import axios from 'axios';
import WeatherCard from './components/WeatherCard';
import './App.css';

const API_KEY = '657377bc95ed7ab7edc45560bba16d56';
const WEATHER_URL = 'https://api.openweathermap.org/data/2.5/weather';
const DEFAULT_CITY = 'Toronto';
const CITY_OPTIONS = [
  'Toronto',
  'Ottawa',
  'Montreal',
  'Vancouver',
  'Calgary',
  'Edmonton',
  'Winnipeg',
  'Halifax',
  'Victoria',
  'Quebec',
];

function App() {
  const [query, setQuery] = useState(DEFAULT_CITY);
  const [city, setCity] = useState(DEFAULT_CITY);
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchWeather(DEFAULT_CITY);
  }, []);

  const fetchWeather = async (targetCity) => {
    if (!targetCity) return;
    setLoading(true);
    setError('');

    try {
      const { data } = await axios.get(WEATHER_URL, {
        params: {
          q: targetCity,
          appid: API_KEY,
          units: 'metric',
        },
      });

      const normalized = {
        city: `${data.name}, ${data.sys?.country ?? ''}`.trim(),
        temp: Math.round(data.main?.temp ?? 0),
        feelsLike: Math.round(data.main?.feels_like ?? 0),
        humidity: data.main?.humidity ?? 0,
        pressure: data.main?.pressure ?? 0,
        wind: data.wind?.speed ?? 0,
        clouds: data.clouds?.all ?? 0,
        description: data.weather?.[0]?.description ?? 'N/A',
        icon: data.weather?.[0]?.icon ?? '01d',
      };

      setWeather(normalized);
      setCity(targetCity);
    } catch (err) {
      setError('Unable to fetch weather. Try another city.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    fetchWeather(query.trim());
  };

  const handleCityChange = (value) => {
    setQuery(value);
    fetchWeather(value);
  };

  return (
    <div className="page">
      <div className="panel">
        <header className="panel-header">
          <div>
            <p className="eyebrow">City Weather Radar</p>
            <h1 className="title">OpenWeatherMap Dashboard</h1>
            <p className="subtitle">Search any city to see real-time conditions, powered by   OpenWeatherMap.</p>
          </div>
          <form className="search" onSubmit={handleSubmit}>
            <label htmlFor="city" className="sr-only">
              City
            </label>
            <select id="city"  value={query} onChange={(e) => handleCityChange(e.target.value)}>
              {CITY_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </form>
        </header>

        <section className="content">
          {loading && <p className="muted">Loading weather...</p>}
          {error && <p className="error">{error}</p>}
          {!loading && !error && weather && <WeatherCard data={weather} key={city} />}
        </section>
      </div>
    </div>
  );
}

export default App;
